<template>
  <div class="breadCrumbs-options-config">
    <el-collapse v-model="activeNames" style="width: 100%">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="显示层级" name="1">
        <template slot="title">
          显示层级
          <i class="tips-btn icon-portal-info2" @click.stop></i>
        </template>
        <div class="content-item verticallyCenter mb12" v-if="pageType === 'detailPage'">
          <el-checkbox v-model="syncListPage">与列表页面包屑一致</el-checkbox>
          <i class="tips-btn icon-portal-info2" @click.stop></i>
        </div>
        <div class="setting-item verticallyCenter" v-if="!syncListPage">
          <span class="mr32 mr12">显示层级</span>
          <div class="font-arrangement-btn height32 flex1">
            <span class="btn-active " :style="getTranslate('')"></span>
            <el-tooltip v-for="(val, index) in zIndexList" :key="index" class="item" effect="dark" :content="val.title"
              placement="top-end" :open-delay="1000">
              <span :key="index" :class="zIndexType == val.label ? 'select pd2' : 'pd2'"
                @click="zIndexType = val.label">{{
      val.title }}</span>
            </el-tooltip>
          </div>
        </div>
        <div v-if="zIndexType === 1 && !syncListPage">
          <div class="mt8" v-if="hasEqualPage">
            <el-checkbox v-model="showEqualHomeName">首页层级</el-checkbox>
            <div class="card mt8" v-if="showEqualHomeName">
              <div class="font-arrangement-btn height32 flex1">
                <span class="btn-active" :style="getTranslate(5)"></span>
                <el-tooltip v-for="(val, index) in zIndexList5" :key="index" class="item" effect="dark"
                  :content="val.title" placement="top-end" :open-delay="1000">
                  <span :key="index" :class="equalHomeNameType == val.label ? 'select pd2' : 'pd2'"
                    @click="equalHomeNameType = val.label">{{ val.title }}</span>
                </el-tooltip>
              </div>
              <el-input v-if="equalHomeNameType === 1" class="mt8" v-model="equalHomeName" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="mt8">
            <el-checkbox v-model="showHomeName">{{hasEqualPage ? "显示页面名称" : "首页层级"}}</el-checkbox>
            <div class="card mt8" v-if="showHomeName">
              <div class="font-arrangement-btn height32 flex1">
                <span class="btn-active" :style="getTranslate(1)"></span>
                <el-tooltip v-for="(val, index) in zIndexList1" :key="index" class="item" effect="dark"
                  :content="val.title" placement="top-end" :open-delay="1000">
                  <span :key="index" :class="homeNameType == val.label ? 'select pd2' : 'pd2'"
                    @click="homeNameType = val.label">{{ val.title }}</span>
                </el-tooltip>
              </div>
              <el-input v-if="homeNameType === 1" class="mt8" v-model="homeName" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="mt8" v-if="!isNav">
            <el-checkbox v-model="showAppName">显示应用名称</el-checkbox>
            <div class="card mt8" v-if="showAppName">
              <div class="font-arrangement-btn height32 flex1">
                <span class="btn-active" :style="getTranslate(2)"></span>
                <el-tooltip v-for="(val, index) in zIndexList2" :key="index" class="item" effect="dark"
                  :content="val.title" placement="top-end" :open-delay="1000">
                  <span :key="index" :class="appNameType == val.label ? 'select pd2' : 'pd2'"
                    @click="appNameType = val.label">{{ val.title }}</span>
                </el-tooltip>
              </div>
              <el-input v-if="appNameType === 1" class="mt8" v-model="appName" placeholder="请输入"></el-input>
            </div>
          </div>
          <div class="mt8">
            <el-checkbox v-model="showClassifyName">显示分类名称</el-checkbox>
            <div class="card mt8" v-if="showClassifyName">
              <div class="font-arrangement-btn height32 flex1">
                <span class="btn-active" :style="getTranslate(3)"></span>
                <el-tooltip v-for="(val, index) in zIndexList3" :key="index" class="item" effect="dark"
                  :content="val.title" placement="top-end" :open-delay="1000">
                  <span :key="index" :class="classifyNameType == val.label ? 'select pd2' : 'pd2'"
                    @click="classifyNameType = val.label">{{ val.title }}</span>
                </el-tooltip>
              </div>
              <div class="flex mt8" v-if="classifyNameType === 1">
                <span class="mr8">最多显示到</span>
                <el-select v-model="classifyName" class="flex1 height32">
                  <el-option v-for="(item, index) in classifyList" :key="index" :selected="classifyName == item.value"
                    :value="item.value" :label="item.title">{{ item.title }}
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="mt8" v-if="pageType === 'detailPage'">
            <el-checkbox v-model="showDataName">显示数据名称</el-checkbox>
            <div class="card mt8" v-if="showDataName">
              <div class="font-arrangement-btn height32 flex1">
                <span class="btn-active" :style="getTranslate(4)"></span>
                <el-tooltip v-for="(val, index) in zIndexList4" :key="index" class="item" effect="dark"
                  :content="val.title" placement="top-end" :open-delay="1000">
                  <span :key="index" :class="dataNameType == val.label ? 'select pd2' : 'pd2'"
                    @click="dataNameType = val.label">{{ val.title }}</span>
                </el-tooltip>
              </div>
              <el-input v-if="dataNameType === 1" class="mt8" v-model="dataName" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
export default {
  name: "breadCrumbs-options-config",
  components: {},
  props: { options: Object },
  data() {
    return {
      collapseActiveNames: ["1", "2", "3"],
      activeNames: ["1", "2", "3"],
      translate: 0,
      translate1: 0,
      translate2: 0,
      translate3: 0,
      translate4: 0,
      translate5: 0,
      zIndexList: [
        {
          label: 0,
          title: "默认"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      zIndexList1: [
        {
          label: 0,
          title: "页面标题"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      zIndexList2: [
        {
          label: 0,
          title: "应用标题"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      zIndexList3: [
        {
          label: 0,
          title: "全部分类"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      zIndexList4: [
        {
          label: 0,
          title: "数据标题"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      zIndexList5: [
        {
          label: 0,
          title: "页面标题"
        },
        {
          label: 1,
          title: "自定义"
        }
      ],
      classifyList: [
        {
          value: 1,
          title: "一级分类"
        }, {
          value: 2,
          title: "二级分类"
        }, {
          value: 3,
          title: "三级分类"
        }, {
          value: 4,
          title: "四级分类"
        }, {
          value: 5,
          title: "五级分类"
        }
      ],
      defaultPageName: "",// 默认首页名称
      defaultAppName: "",// 默认应用名称
      defaultClassifyName: [],// 默认分类名称
      appId: "",
      subPage: [],
      isNav: false,
      hasEqualPage: false,
      homeIndex: 0,
      appIndex: 1
    }
  },
  comments: {},
  mounted() {
    // 判断是否是导航菜单的子页面
    this.appId = this.$store.state?.states?.getDataPageIds?.appId
    if (this.appId && (this.pageType === "listPage" || this.pageType === "detailPage")) {
      let subPageSetting = window.localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix)
      this.subPage = subPageSetting && JSON.parse(subPageSetting) || {}
      this.isNav = this.subPage?.nav
    }
    this.hasEqualPage = this.$store.state?.states?.getDataPageIds?.hasEqualPage // 是否是平级页面的子页面
    if (this.sourceData[0]?.value === "equalPageHome") {// 多加一个平级页面首页
      this.homeIndex = 1
      this.appIndex = 2
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    syncListPage: {
      get() {
        return this.crumbsSetting.hasOwnProperty("syncListPage") ? this.crumbsSetting.syncListPage : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "crumbsSetting.syncListPage", false)
      }
    },
    getTranslate() {
      return function (type) {
        return {
          transform:`translateX(${this[`translate${type}`]}px)`
        }
      }
    },
    zIndexType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("zIndexType") ? this.crumbsSetting.zIndexType : 0
        let index = this.zIndexList.findIndex(item => item.label === type)
        // 77.5 一个滑块的宽度
        this.translate = 77.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList.findIndex(item => item.label === newVal)
        this.translate = 77.5 * index
        this.$changeOptionsEV(newVal, "crumbsSetting.zIndexType", false)
        this.updateSubPageSetting("zIndexType", newVal)
      }
    },
    sourceData() {
      return this.options.sourceData || []
    },
    crumbsSetting() {
      if (!this.options.hasOwnProperty("crumbsSetting")) {
        this.$changeOptionsEV({}, "crumbsSetting", false, false, false, true)
      }
      return this.options.crumbsSetting
    },
    showHomeName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("showHomeName") ? this.crumbsSetting.showHomeName : this.hasEqualPage ? false : true
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.showHomeName", false)
        // this.updateSubPageSetting("showHomeName", newVal)
        this.changeCrumbsSetting("showHomeName", newVal)
      }
    },
    homeName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("homeName") ? this.crumbsSetting.homeName : this.sourceData[this.homeIndex]?.label || ""
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.homeName", false)
        // this.updateSubPageSetting("homeName", newVal)
        this.changeCrumbsSetting("homeName", newVal)
      }
    },
    homeNameType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("homeNameType") ? this.crumbsSetting.homeNameType : 0
        let index = this.zIndexList.findIndex(item => item.label === type)
        this.translate1 = 96.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList.findIndex(item => item.label === newVal)
        this.translate1 = 96.5 * index
        // this.$changeOptionsEV(newVal, "crumbsSetting.homeNameType", false)
        // this.updateSubPageSetting("homeNameType", newVal)
        this.changeCrumbsSetting("homeNameType", newVal, this.sourceData[this.homeIndex]?.label)
      }
    },
    showAppName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("showAppName") ? this.crumbsSetting.showAppName : true
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.showAppName", false)
        // this.updateSubPageSetting("showAppName", newVal)
        this.changeCrumbsSetting("showAppName", newVal)
      }
    },
    appName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("appName") ? this.crumbsSetting.appName : this.sourceData[this.appIndex]?.label || ""
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.appName", false)
        // this.updateSubPageSetting("appName", newVal)
        this.changeCrumbsSetting("appName", newVal)
      }
    },
    appNameType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("appNameType") ? this.crumbsSetting.appNameType : 0
        let index = this.zIndexList.findIndex(item => item.label === type)
        this.translate2 = 96.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList.findIndex(item => item.label === newVal)
        this.translate2 = 96.5 * index
        // this.$changeOptionsEV(newVal, "crumbsSetting.appNameType", false)
        // this.updateSubPageSetting("appNameType", newVal)
        this.changeCrumbsSetting("appNameType", newVal, this.sourceData[this.appIndex]?.label)
      }
    },
    showClassifyName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("showClassifyName") ? this.crumbsSetting.showClassifyName : true
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.showClassifyName", false)
        // this.updateSubPageSetting("showClassifyName", newVal)
        this.changeCrumbsSetting("showClassifyName", newVal)
      }
    },
    classifyName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("classifyName") ? this.crumbsSetting.classifyName : 5
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.classifyName", false)
        // this.updateSubPageSetting("classifyName", newVal)
        this.changeCrumbsSetting("classifyName", newVal)
      }
    },
    classifyNameType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("classifyNameType") ? this.crumbsSetting.classifyNameType : 0
        let index = this.zIndexList.findIndex(item => item.label === type)
        this.translate3 = 96.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList.findIndex(item => item.label === newVal)
        this.translate3 = 96.5 * index
        // this.$changeOptionsEV(newVal, "crumbsSetting.classifyNameType", false)
        // this.updateSubPageSetting("classifyNameType", newVal)
        this.changeCrumbsSetting("classifyNameType", newVal, 5)
      }
    },
    showDataName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("showDataName") ? this.crumbsSetting.showDataName : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "crumbsSetting.showDataName", false)
      }
    },
    dataName: {
      get() {
        const index = this.sourceData?.length - 1
        return this.crumbsSetting.hasOwnProperty("dataName") ? this.crumbsSetting.dataName : this.sourceData[index]?.label || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "crumbsSetting.dataName", false)
      }
    },
    dataNameType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("dataNameType") ? this.crumbsSetting.dataNameType : 0
        let index = this.zIndexList.findIndex(item => item.label === type)
        this.translate4 = 96.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList.findIndex(item => item.label === newVal)
        this.translate4 = 96.5 * index
        this.$changeOptionsEV(newVal, "crumbsSetting.dataNameType", false)
      }
    },
    showEqualHomeName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("showEqualHomeName") ? this.crumbsSetting.showEqualHomeName : this.hasEqualPage ? true : false
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.showEqualHomeName", false)
        // this.updateSubPageSetting("showEqualHomeName", newVal)
        this.changeCrumbsSetting("showEqualHomeName", newVal)
      }
    },
    equalHomeName: {
      get() {
        return this.crumbsSetting.hasOwnProperty("equalHomeName") ? this.crumbsSetting.equalHomeName : this.sourceData[0]?.label || ""
      },
      set(newVal) {
        // this.$changeOptionsEV(newVal, "crumbsSetting.equalHomeName", false)
        // this.updateSubPageSetting("equalHomeName", newVal)
        this.changeCrumbsSetting("equalHomeName", newVal)
      }
    },
    equalHomeNameType: {
      get() {
        let type = this.crumbsSetting.hasOwnProperty("equalHomeNameType") ? this.crumbsSetting.equalHomeNameType : 0
        let index = this.zIndexList5.findIndex(item => item.label === type)
        this.translate5 = 96.5 * index
        return type
      },
      set(newVal) {
        let index = this.zIndexList5.findIndex(item => item.label === newVal)
        this.translate5 = 96.5 * index
        // this.$changeOptionsEV(newVal, "crumbsSetting.equalHomeNameType", false)
        // this.updateSubPageSetting("equalHomeNameType", newVal)
        this.changeCrumbsSetting("equalHomeNameType", newVal, this.sourceData[0]?.label)
      }
    },
  },
  methods: {
    changeTranslate(value) {
      this.zIndexType = value
    },
    changeCrumbsSetting(type, val, defaultVal) {
      console.log('`crumbsSetting.${type}` :>>',`crumbsSetting.${type}`);
      this.$changeOptionsEV(val, `crumbsSetting.${type}`, false)
      this.updateSubPageSetting(type, val)
      if (val && type.includes("Type")) {
        const name = type.replace("Type", "")
        if (!this.crumbsSetting.hasOwnProperty(name)) {
          this.$changeOptionsEV(defaultVal, `crumbsSetting.${name}`, false)
          this.updateSubPageSetting(name, defaultVal)
        }
      }
    },
    updateSubPageSetting(type, val) {
      if (this.pageType !== "listPage") return
      const appId = this.$store.state.states.getDataPageIds.appId
      let subPageSetting = window.localStorage.getItem("subPageSetting-" + appId + "-" + this.request_prefix)
      let subPage = subPageSetting && JSON.parse(subPageSetting) || {}
      let crumbsSetting = subPage.crumbsSetting && JSON.parse(JSON.stringify(subPage.crumbsSetting)) || {}
      crumbsSetting[type] = val
      subPage.crumbsSetting = crumbsSetting
      localStorage.setItem("subPageSetting-" + appId + "-" + this.request_prefix, JSON.stringify(subPage))
      // 通知首页更新面包屑设置，用于详情页同步列表页面包屑
      const subPageEditInfo = this.$store.state.states.subPageEditInfo
      subPageEditInfo.edit = true
      subPageEditInfo.type = "crumbs"
      subPageEditInfo.value = "crumbsSetting"
    }
  }
}
</script>

<style scoped>
.toolbar .card {
  padding: 12px;
}

.font-arrangement-btn .btn-active {
  width: calc((100% - 9px) / 2);
}

.font-arrangement-btn span {
  font-size: 14px;
}
</style>
